module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00437.92edd009.jpg";